import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  logotype: {
    color: "white",
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    fontWeight: 500,
    fontSize: 18,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  logo: {
    width: 400,
    [theme.breakpoints.down("xs")]: {
      width: 200,
    },
  },
  title: {
    fontSize: 19,
    fontWeight: "bold",
  },
  logoBanader: {
    height: 50,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  appBar: {
    width: "100vw",
    // height: "7%",
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // background: theme.palette.background.header,
    background: "linear-gradient(to right, #5acaf2, #8fdcf7, #c1e9f7)",
  },
  handleContainer: {
    width: "100%",
    position: "absolute",
    height: 35,
    bottom: -35,
    display: "flex",
    justifyContent: "center",
  },
  handle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 85,
    height: 35,
    background: theme.palette.background.header,
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: "flex",
    alignItems: "centre",
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },
  menu: {
    display: "flex",
    flexDirection: "row",
    marginRight: theme.spacing(1),
  },
  toggleMenuButton: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  servicesList: {
    position: "fixed",
    top: 75,
    right: 10,
    // width: "90vw",
    background: "rgba(0,0,0,0.6)",
    borderRadius: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  serviceContainer: {
    width: 100,
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "center",
    padding: 10,
    margin: 20,
    border: "1px solid",
    background: "white",
    borderRadius: 10,
  },
  serviceImage: {
    height: "40%",
    maxWidth: "100%",
    margin: "auto",
  },
  serviceTitle: {
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
  },
  serviceDescription: {
    fontSize: 11,
    textAlign: "center",
  },
}));
